import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

const ILLUSTRATION_URL =
  'https://res.cloudinary.com/zenbusiness/image/upload/v1/shared-assets/illustration/subscription-updated.svg';

export default function RequestSuccessful({ onClose }) {
  const { formatMessage } = useIntl();

  return (
    <>
      <DialogContent>
        <Stack alignItems="center" sx={{ textAlign: 'center', py: 2 }}>
          <Box
            component="img"
            src={ILLUSTRATION_URL}
            alt={formatMessage({ id: 'dashboard.subscriptions.success.imageAlt' })}
            sx={{ width: '50%', maxWidth: 256, mb: 3 }}
          />
          <Text size="xl" weight="bold" align="center" sx={{ mb: 1 }}>
            <FormattedMessage id="dashboard.subscriptions.success.title" />
          </Text>
          <Text size="md" align="center" color="secondary">
            <FormattedMessage id="dashboard.subscriptions.success.body" />
          </Text>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 3 }}>
        <Button variant="contained" onClick={onClose} clickstreamProps={{ elementName: 'restart_success_close' }}>
          <FormattedMessage id="dashboard.subscriptions.success.ok" />
        </Button>
      </DialogActions>
    </>
  );
}

RequestSuccessful.propTypes = {
  onClose: PropTypes.func.isRequired,
};
